module.exports = __webpack_public_path__ + "static/media/pathao.58d20066.png";